export enum UnitType {
  ABSOLUTE = 'ABSOLUTE',
  DURATION = 'DURATION',
  LENGTH = 'LENGTH',
  PERCENTAGE = 'PERCENTAGE',
  SPEED = 'SPEED',
  WEIGHT = 'WEIGHT',
}
